module.exports = __webpack_public_path__ + "static/glue-41f81294860f668adcea5f085f4475ee.png";